
import { SFConstants } from "../../../constants/SFConstants";
import { ErrorCodes } from "../../../constants/shared/ErrorCodes";
import { AvatarCreationEvent } from "../../../event/AvatarCreationEvent";
import { Poker2Model } from "../../../model/Poker2Model";
import { Poker2Command } from "../Poker2Command";

export class LCACommand extends Poker2Command {
    protected get cmdId(): string {
        return "lca";
    }

    public executeCommand(error: number, params: any[]): boolean {
        switch (error) {
            case 0:
                var paramsObj: any = JSON.parse(params[1]);
                Poker2Model.userData.guestName = paramsObj.guestName;
                Poker2Model.userData.firstLogin = true;
                this.controller.dispatchEvent(new AvatarCreationEvent("avatarcreationsuccessfull"));
                return true;
        }
        return super.executeCommand(error, params);
    }

    /**
    * TRANSPILER GENERATED FUNCTION: If a overriding getter is defined, the setter must be defined as well. WARNING: the defining class was not found, so the parentclass was assumed. Please check if this call is correct.
    **/
    protected set cmdId(value/*:String*/)/*:void*/ {
        Object.getOwnPropertyDescriptor(Poker2Command.prototype, "cmdId").set.call(this, value);
    }
}
